// Ubicación en el repo: src/components/SupplierFormModal.jsx
// Modal Crear/Editar proveedor (Fase A del módulo de Inventario/
// Contabilidad, migración 0046, 24-ago-2026). Entidad nueva, sin
// equivalente previo en el software — hoy solo se asocia opcionalmente a
// un producto del catálogo; las Fases D en adelante (compras/gastos) la
// van a usar más.
import { useState } from 'react';
import { createSupplier, updateSupplier } from '../lib/suppliers';

function emptyForm() {
  return { name: '', rut: '', contactName: '', phone: '', email: '' };
}

function supplierToForm(s) {
  return {
    name: s.name ?? '',
    rut: s.rut ?? '',
    contactName: s.contact_name ?? '',
    phone: s.phone ?? '',
    email: s.email ?? '',
  };
}

export default function SupplierFormModal({ supplier, onClose, onSaved }) {
  const isEdit = !!supplier;
  const [form, setForm] = useState(() => (isEdit ? supplierToForm(supplier) : emptyForm()));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function set(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.name.trim()) {
      setError('El nombre es obligatorio.');
      return;
    }
    setSaving(true);
    try {
      if (isEdit) {
        await updateSupplier(supplier.id, form);
      } else {
        await createSupplier(form);
      }
      onSaved();
    } catch (err) {
      setError(err.message || 'No se pudo guardar el proveedor.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>{isEdit ? 'Editar proveedor' : 'Nuevo proveedor'}</h2>
        <form onSubmit={handleSubmit} className="patient-form">
          <label className="field">
            <span>Nombre / razón social *</span>
            <input value={form.name} onChange={(e) => set('name', e.target.value)} autoFocus />
          </label>
          <div className="form-row">
            <label className="field">
              <span>RUT</span>
              <input value={form.rut} onChange={(e) => set('rut', e.target.value)} />
            </label>
            <label className="field">
              <span>Contacto</span>
              <input value={form.contactName} onChange={(e) => set('contactName', e.target.value)} placeholder="Nombre de contacto" />
            </label>
          </div>
          <div className="form-row">
            <label className="field">
              <span>Teléfono</span>
              <input value={form.phone} onChange={(e) => set('phone', e.target.value)} />
            </label>
            <label className="field">
              <span>Correo</span>
              <input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} />
            </label>
          </div>
          {error && <p className="auth-error">{error}</p>}
          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="button-primary" disabled={saving}>
              {saving ? 'Guardando…' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
